module.exports = __webpack_public_path__ + "img/remenber-calc.81195a61.png";